"use strict";

var _ = require('lodash');

var React = require('react');

var displayNames = require('../displayNames');

var TextFormattingToggleButton = require('../textFormattingToggleButton');

var TextFormattingButtonWithDropDown = require('../textFormattingButtonWithDropDown');

var symbols = {
  bold: require('../icons/textBold.svg.js'),
  italic: require('../icons/textItalic.svg.js'),
  underline: require('../icons/textUnderline.svg.js'),
  link: require('../icons/textLink.svg.js'),
  unlink: require('../icons/textUnlink.svg.js'),
  color: require('../textFormattingColor'),
  highlight: require('../textFormattingHighlight')
};

var buildTextFormattingComp = function buildTextFormattingComp(name, symbol) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var CompClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextFormattingToggleButton;

  var Comp = function Comp(props) {
    return React.createElement(CompClass, _.defaults({
      name: name
    }, props), React.createElement(symbol, props));
  };

  Comp.displayName = name;
  Comp.defaultProps = defaultProps;
  return Comp;
};

module.exports = {
  bold: buildTextFormattingComp(displayNames.TEXT_BOLD_BUTTON, symbols.bold),
  italic: buildTextFormattingComp(displayNames.TEXT_ITALIC_BUTTON, symbols.italic),
  underline: buildTextFormattingComp(displayNames.TEXT_UNDERLINE_BUTTON, symbols.underline),
  link: buildTextFormattingComp(displayNames.TEXT_LINK_BUTTON, symbols.link, {
    hasBackgroundWhenSelected: true,
    options: [{
      value: false,
      content: React.createElement(symbols.unlink),
      key: 'false'
    }, {
      value: true,
      content: React.createElement(symbols.link),
      key: 'true'
    }]
  }, TextFormattingButtonWithDropDown),
  color: buildTextFormattingComp(displayNames.TEXT_COLOR_BUTTON, symbols.color, {
    value: false,
    onChange: _.noop
  }),
  highlight: buildTextFormattingComp(displayNames.TEXT_HIGHLIGHT_BUTTON, symbols.highlight, {
    value: false,
    onChange: _.noop
  })
};